import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PackageCarousel from "../components/Packagecarousel";
import ItineraryAccordion from "../components/ItineraryAccordion";
import StickyCTA from "../components/StickyCTA";
import axios from "axios";
import BookingModal from "../components/BookingModal"; // ✅ Reusable booking modal
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PackageDetails() {
  // const location = useLocation();
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);


  // Package passed via Link state
  const { slug } = useParams();

  const [pkg, setPkg] = useState(null);
  const [showBooking, setShowBooking] = useState(false);
  const token = localStorage.getItem("token");
  useEffect(() => {
    const fetchPackage = async () => {
      setLoading(true);

      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const endpoint = `${apiUrl}/packages/slug/${slug}`;

        const { data } = await axios.get(endpoint,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : undefined,
            },
          });
        console.log(data);


        setPkg(data);
      } catch (err) {
        console.error(err);
        toast.error(
          err.response?.data?.message || "Failed to load package details"
        );
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPackage();
    }
  }, [slug, token]);

  if (loading) return (
    <div className="text-center mt-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3">Loading Details...</p>
    </div>
  );
  console.log("Package details loaded:", pkg); // Debug log

  const images = Array.isArray(pkg.images) && pkg.images.length > 0
    ? pkg.images
    : pkg.image
      ? [{ url: pkg.image, caption: "" }]
      : [];
  return (
    <>
      <Helmet>
        <title>{pkg.title} | Primedale Tours</title>
        <meta name="description" content={pkg.shortDescription} />
        <meta property="og:image" content={images[0]} />
      </Helmet>

      {/* Hero Section */}
      <div
        className="container-fluid bg-primary py-5 mb-5"
        style={{
          backgroundImage: `linear-gradient(rgba(20, 20, 31, 0.7), rgba(20, 20, 31, 0.7)), url(${pkg.image})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">{pkg.title}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5 mb-5">
        <Link to="/packages" className="btn btn-outline-secondary mb-4">
          ← Back to Packages
        </Link>

        <div className="row g-5">
          <div className="col-lg-6">
            <PackageCarousel images={images} title={pkg.title} />
          </div>

          <div className="col-lg-6">
            <h1>{pkg.title}</h1>

            <p className="text-muted">
              <i className="fa fa-map-marker-alt me-2" />
              {pkg.destination}
            </p>

            <p className="text-muted">
              <i className="fa fa-calendar-alt me-2" />
              {pkg.duration}
            </p>

            <div className="mb-4" dangerouslySetInnerHTML={{ __html: pkg.shortDescription }} />

            {/* ✅ Book This Package Button */}
            <button className="btn navyblue-bg mb-4" onClick={() => setShowBooking(true)}>
              Request Quote
            </button>

            <ItineraryAccordion itinerary={pkg.itinerary} />
          </div>

          <div dangerouslySetInnerHTML={{ __html: pkg.description }} />
        </div>
      </div>

      {/* Sticky CTA */}
      <StickyCTA onBook={() => setShowBooking(true)} phone="254745715136" />

      {/* ✅ Booking Modal */}
      {showBooking && pkg && <BookingModal pkg={pkg} onClose={() => setShowBooking(false)} />}
    </>
  );
}

export default PackageDetails;
